import { AttributeModel } from "../main/dynamic/model/attribute.model"

export class InstanceModel {
    id: string
    processId: string
    attributes: AttributeModel[]
    preEvents: AttributeModel[]
    postEvents: AttributeModel[]
    filters: AttributeModel[]
    options: AttributeModel[]
    childrenSteps: InstanceModel[]
    nextStep?: InstanceModel
    state: string

    constructor() {
        this.attributes = []
        this.preEvents = []
        this.postEvents = []
        this.filters = []
        this.options = []
        this.childrenSteps = []
    }
}